import { FastField, Field } from 'formik';
import { FormField, Input } from '@shipengine/formik-giger';
import { Icon, IconSize } from '@shipengine/giger';
import { IconNames } from '@shipengine/giger-theme';
import { useTranslation } from '@packlink/translation-provider';
import { FieldNames } from './InvoiceForm.js';
import { getFieldStyles, getCheckIConStyles } from './InvoiceFormStyles.js';
import { usePhoneNumberVerification } from '../hooks/usePhoneNumberVerification.js';
import { FormikPhoneNumber } from './FormikPhoneNumber.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { ContactFormOrientation } from '../types/types.js';
import { useDisabledFields } from '../contexts/disabledFields.js';

const InvoiceContactForm = _ref => {
  let {
    orientation = ContactFormOrientation.HORIZONTAL,
    phonePrefixOptions,
    isPhoneNumberVerified,
    requiresPhoneNumberVerification,
    cdnUrl
  } = _ref;
  const {
    showDefaultPhoneInput,
    showVerificationPhoneInput
  } = usePhoneNumberVerification(requiresPhoneNumberVerification, isPhoneNumberVerified);
  const {
    t
  } = useTranslation();
  const {
    isFieldDisabled
  } = useDisabledFields();
  return jsxs("div", {
    css: getFieldStyles(orientation === ContactFormOrientation.HORIZONTAL, true),
    "aria-label": "contact-info",
    children: [jsx(FormField, {
      name: FieldNames.EMAIL,
      children: jsx(FastField, {
        disabled: isFieldDisabled(FieldNames.EMAIL),
        component: Input,
        label: t('invoice-form.label.email'),
        type: "email"
      })
    }), showVerificationPhoneInput ? jsx(FormField, {
      name: FieldNames.PHONE,
      children: jsx(Field, {
        name: FieldNames.PHONE,
        component: FormikPhoneNumber,
        disabled: isFieldDisabled(FieldNames.PHONE),
        prefixOptions: phonePrefixOptions,
        cdnUrl: cdnUrl
      })
    }) : showDefaultPhoneInput && jsx(FormField, {
      name: FieldNames.PHONE,
      children: jsx(Field, {
        disabled: requiresPhoneNumberVerification && isPhoneNumberVerified || isFieldDisabled(FieldNames.PHONE),
        component: Input,
        label: t('invoice-form.label.phone'),
        type: "tel",
        rightContent: requiresPhoneNumberVerification && isPhoneNumberVerified && jsx(Icon, {
          name: IconNames.CHECK,
          size: IconSize.SIZE_MEDIUM,
          css: getCheckIConStyles
        })
      })
    })]
  });
};
var InvoiceContactForm$1 = InvoiceContactForm;

export { InvoiceContactForm$1 as default };
//# sourceMappingURL=InvoiceContactForm.js.map
